module.exports = {
  name: (name) => {
    return name.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
  },
  
  
  ucwords: (string) => {
    return string.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
  },
  
  
  address: (string) => {
    // the spaces inbetween | e | w |, etc, are intentional...  do not remove them.
    string = string.replace("nw", "NW");
    string = string.replace("ne", "NE");
    string = string.replace("sw", "SW");
    string = string.replace("se", "SE");
    return string.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
  },
  
  
  email: (email) => {
    // add regex to remove special chars
    // allowable characters !#$%&'*+-/=?^_`{|}~
    email = email.replace(/[`();:",<>\[\]\\\/]/gi, "");
    return email.toLowerCase();
  },
  
  
  phone: (phone) => {
    if (Number.isInteger(phone) == true) return phone;
    phone = phone.replace(/[^0-9]/g, '');
    return parseInt(phone);
  },
  
  
  username: (username) => {
    username = username.toLowerCase();
    username = username.replace(/[^a-z0-9_]/g, '');
    return username;
  },
  
  
  bio: (str) => {
    // might want to fill this out...
  },
  
  
}

// let addresses = ["1234 main st", "2247 w evergreen st", "2247 e evergreen st", "2247 n evergreen st", "2247 s evergreen st", "2247 se evergreen st", "2247 sw evergreen st", "2247 ne evergreen st", "2247 nw evergreen st", ];
// for (let i in addresses) {
// 	console.log(module.exports.address(addresses[i]));
// }

// console.log("email:", module.exports.email("asdf@asdf.com") );
// console.log("email:", module.exports.email("asdf234@-<asdf.com") );

// console.log("phone:", module.exports.phone("213-995-7078"));
// console.log("phone:", module.exports.phone("+1-213-995-7078"));

// console.log("username:", module.exports.username("MyDick69"));
// console.log("username:", module.exports.username("hUnGpUppY++"));

